import { Trash2 } from "lucide-react";
import { fmtDate, fmtTime, toUtc } from "@/lib/mood";
import { MOOD_OPTIONS } from "@/data/journal";
import { HelpedQuoteButton } from "@/components/playbook/HelpedQuoteButton";

export const JournalEntryCard = ({ e, onDelete }) => {
  const d = toUtc(e.date);
  const mood = e.mood && MOOD_OPTIONS.find((m) => m.label === e.mood);
  return (
    <div className="mm-card p-5" data-testid={`journal-entry-${e.id}`}>
      <div className="flex justify-between text-xs text-mm-muted">
        <span>{fmtDate(d, { weekday: "short", month: "short", day: "numeric" })} · {fmtTime(d)} {e.mood && `· ${mood ? `${mood.emoji} ${e.mood}` : e.mood}`}</span>
        <button onClick={() => onDelete(e.id)} data-testid={`journal-delete-${e.id}`}><Trash2 size={14} /></button>
      </div>
      <p className="text-sm font-semibold text-mm-primary mt-2">{e.prompt}</p>
      <p className="mt-1 whitespace-pre-wrap">{e.text}</p>
      <HelpedQuoteButton text={e.text} source="journal" testId={`journal-helped-${e.id}`} className="mt-3" />
    </div>
  );
};
